// Shared styles for enaibl page components
export const styles = `
  .calc-slider {
    -webkit-appearance: none;
    background: rgba(255,255,255,0.1);
    height: 4px;
    border-radius: 2px;
  }
  .calc-slider::-webkit-slider-thumb {
    -webkit-appearance: none;
    width: 14px;
    height: 14px;
    border-radius: 50%;
    background: white;
    cursor: pointer;
    box-shadow: 0 0 15px rgba(255,255,255,0.4);
  }
  .calc-slider::-moz-range-thumb {
    width: 14px;
    height: 14px;
    border-radius: 50%;
    background: white;
    cursor: pointer;
    border: none;
  }
`;
